import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appSelectAllOnClick]',
  host: {
    '(focus)': 'onFocus()',
    '(blur)': 'onBlur()',
  },
})
export class SelectAllOnClickDirective {
  public hasSelectedAll = false;

  constructor(private elementRef: ElementRef) {}

  onFocus() {
    const input: HTMLInputElement = this.elementRef.nativeElement;

    setTimeout(() => {
      if (!this.hasSelectedAll) {
        try {
          // iOS, Safari, throws exception on Chrome, etc.
          input.selectionStart = 0;
          input.selectionEnd = input.value.length + 1;
          this.hasSelectedAll = true;
        } catch (err) {
          // Non-iOS option if not supported, e.g., Chrome
          input.select();
          this.hasSelectedAll = true;
        }
      }
    });
  }

  onBlur() {
    this.hasSelectedAll = false;
  }
}
